'use client';
import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const ModelPricing = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 5px;

  label {
    display: flex;
    align-items: center;
    gap: 5px;
    small {
      font-weight: 400;
    }
  }

  @media (max-width: ${breakPoints.mobile}) {
    flex-direction: column;
  }
`;
